import { NetworkConstants } from './types';

export class NetworkActions {
  static updateLastRequest(request) {
    return { type: NetworkConstants.SetLastRequest, payload: request };
  }

  static clearLastRequest() {
    return { type: NetworkConstants.ClearLastRequest };
  }
}
